import { useState, useEffect, useRef } from "react";
import * as Tone from "tone";
import { PIANO_URLS, SALAMANDER_BASE, GUITAR_URLS, GUITAR_BASE, DRUM_URLS, DRUM_BASE } from "./samples/sampleConfig";

export interface SampleKit {
  piano: Tone.Sampler;
  guitar: Tone.Sampler;
  drums: Tone.Players;
}

export interface UseSamplesResult {
  loaded: boolean;
  samples: SampleKit | null;
}

export function useSamples(): UseSamplesResult {
  const [loaded, setLoaded] = useState(false);
  const kitRef = useRef<SampleKit | null>(null);

  useEffect(() => {
    const piano = new Tone.Sampler({
      urls: PIANO_URLS,
      baseUrl: SALAMANDER_BASE,
      attack: 0.03,
    }).toDestination();

    const guitar = new Tone.Sampler({
      urls: GUITAR_URLS,
      baseUrl: GUITAR_BASE,
      attack: 0.01,
    }).toDestination();

    const drums = new Tone.Players({
      urls: DRUM_URLS,
      baseUrl: DRUM_BASE,
    }).toDestination();

    kitRef.current = { piano, guitar, drums };

    Tone.loaded().then(() => setLoaded(true));

    return () => {
      piano.dispose();
      guitar.dispose();
      drums.dispose();
      kitRef.current = null;
      setLoaded(false);
    };
  }, []);

  return { loaded, samples: loaded ? kitRef.current : null };
}
